import { useEffect, useState, useCallback, useMemo } from "react";
import "./TutorsDashboardLayout.scss";
import TutorMaps from "../../Components/TutorMaps/TutorMaps";
import activitiesIcon from "../../Assets/Activities/activitiesIcon.svg";
import schoolIocn from "../../Assets/School/schoolIocn.svg";
import themeParkIcon from "../../Assets/SideBar/themeParkActive.svg";
import universityIcon from "../../Assets/University/universityIcon.svg";
import TutorCardsCarousel from "../../Components/TutorCardsCarousel/TutorCardsCarousel";
import TopTutors from "../../Components/TopTutors/TopTutors";
import search from "../../Assets/Tutor/searchIconGray.svg";
import TutorImg from "../../Assets/Tutor/TutorImg.svg";
import Chemistry from "../../Assets/Tutor_Subjects/Chemistry.svg";
import tutorImg1 from "../../Assets/Tutor/tutorImg1.png";
import tutorImg4 from "../../Assets/Tutor/tutorImg4.png";
import { useNavigate } from "react-router-dom";
import {
  API_END_POINTS,
  FILTER_CONSTANT,
  GLOBAL_CONSTANTS,
  ROUTES,
} from "../../Constants/Constants";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { store } from "../../Redux/Store/Store";
import { setInitTutorFilter, setLoader, setTutorFilter } from "../../Redux/Reducer/Reducer";
import axios from "axios";
import {
  GetSessionStorageData,
  SetSessionStorageData,
  encryptPassData,
  isObjectEmptyValue,
  nullUndefinedEmptyCheck,
} from "../../Utilities/Helpers/Helper";
import ExpandMap from "../../Assets/Activities/ExpandMap.svg";
import { useSelector } from "react-redux";
import TutorCategoryPopup from "./TutorCategoryPopup/TutorCategoryPopup";
import AppFilter from "../../Components/AppFilter.tsx/AppFilter";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from "@mui/material/Box";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { useMediaQuery, useTheme } from "@mui/material";
import { debounce } from 'lodash';

const apiCache = new Map();

const TutorsDashboardLayout = () => {
  const tutor_search = GetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.TUTOR);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(tutor_search ? tutor_search : "");
  const [coursecategory, setCoursecategory] = useState([]);
  const [promotionalContent, setPromotionalContent] = useState([]);
  const [tutorList, setTutorList] = useState<any>([]);
  const [list, setList] = useState<any>([]);
  const [searchTextList, setSearchTextList] = useState([]);
  const [currentLat, setCurrentLat] = useState<any>(null); 
  const [currentLang, setCurrentLang] = useState<any>(null); 
  const [IsTrigger, setIsTrigger] = useState<any>(false);
  const [ResetBoolean, setResetBoolean] = useState(false);
  const [itemsToShow, setItemsToShow] = useState<any>(7);
  const [CategoryPopOpen, setCategoryPopOpen] = useState(false);
  const { t } = useTranslation();

  const tutorfilter: any = useSelector((state: any) => {
    return state.filterReducer.tutorfilter;
  });

  const init_tutorfilter: any = useSelector((state: any) => {
    return state.initFilterReducer.initTutorfilter;
  });

  const init_filter = {
    courses: [],
    curriculum: [],
    price: [0, 0],
    mode_of_teaching: [],
    experience: [0, 0],
    rating: 0,
    gender: [],
    grade: [0, 0],
    radius: 10,
  };
  const [FilterPopOpen, setFilterPopOpen] = useState(false);
  const [FilterData, setFilterData] = useState<any>([]);
  const [initFilter, setInitFilter] = useState<any>(isObjectEmptyValue(init_tutorfilter) ? init_tutorfilter : init_filter);
  const [FilterApplyData, setFilterApplyData] = useState<any>(init_filter);
  const [initSort, setSort] = useState<any>({
    price: '',
    rating: ''
  });

  const onOpenFilterPop = () => {
    setFilterPopOpen(true);
  };

  const onCloseFilterPop = () => {
    setFilterPopOpen(false);
  };

  const handleShowMore = () => {
    setCategoryPopOpen(true);
  };

  const containerStyle = {
    width: "100%",
    height: "400px", 
  };

  const handleRouteMap = (value: any) => {
    SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.TUTOR, value);
    navigate(ROUTES.TUTORS_MAPS_VIEW, {
      state: {
        tutor_list: tutorList,
        search_text: value,
        redius: FilterApplyData.radius,
        lat: currentLat,
        lang: currentLang,
        filter: FilterApplyData,
        filterBoolean: IsTrigger,
      },
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const HeaderLoction: any = useSelector((state: any) => {
    return state.locationReducer.location;
  });

  const debouncedTutorListApi = useMemo(() => debounce((lat, lng, value, filter) => {
    TutorListApi(lat, lng, value, filter);
  }, 300), []);

  useEffect(() => {
    if (HeaderLoction?.lat && HeaderLoction?.lng) {
      setCurrentLat(HeaderLoction.lat);
      setCurrentLang(HeaderLoction.lng);
    } else {
      setCurrentLat(25.2048); 
      setCurrentLang(55.2708); 
    }
  }, [HeaderLoction]);

  useEffect(() => {
    if (currentLat && currentLang) {
      if (tutorfilter && isObjectEmptyValue(tutorfilter)) {
        debouncedTutorListApi(currentLat, currentLang, searchValue, tutorfilter);
      } else {
        debouncedTutorListApi(currentLat, currentLang, searchValue, FilterApplyData);
      }
    }
  }, [currentLat, currentLang, ResetBoolean, FilterApplyData, debouncedTutorListApi]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [filterResponse, promotionalResponse, courseResponse] = await Promise.all([
          axiosInstance.get(`${API_END_POINTS.TUTORFILTERLIST}`),
          axiosInstance.get(`${API_END_POINTS.PROMOTIONAL_CONTENT_LIST}?service_provider_type=1`),
          axiosInstance.get(`${API_END_POINTS.TUTOR_COURSE_CATEGORIES}`),
        ]);

        if (filterResponse?.data?.status) {
          let data = filterResponse?.data?.result?.data;
          setFilterData(data);
          if (data) {
            let init = {
              courses: [],
              curriculum: [],
              price: [data.price?.min, data.price?.max],
              mode_of_teaching: [],
              experience: [data.experience?.min, data.experience?.max],
              rating: 0,
              gender: [],
              grade: [data.grade?.min, data.grade?.max],
              radius: 10,
            };
            store.dispatch(setInitTutorFilter(init));
            SetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.TUTOR, JSON.stringify(init));
            setInitFilter(init);
            setFilterApplyData(isObjectEmptyValue(tutorfilter) ? tutorfilter : init);
          }
        }

        if (promotionalResponse?.data?.status) {
          let data = promotionalResponse?.data?.result?.data;
          data.sort((a: any, b: any) => a.id - b.id);
          setPromotionalContent(data);
        }

        if (courseResponse?.data?.status) {
          setCoursecategory(courseResponse?.data?.result?.data);
        }
      } catch (error) {}
    };
    fetchInitialData();
  }, []);

  const payload = (
    latitude: any,
    longitude: any,
    value: string,
    filter: any
  ) => {
    const pay: any = {
      latitude: latitude?.toString(),
      longitude: longitude?.toString(),
      radius: filter.radius,
      search: value ? value : "",
      courses: filter.courses,
      mode_of_teaching: filter.mode_of_teaching,
      gender: filter.gender,
      curriculum: filter.curriculum,
      rating: filter.rating,
    };

    if (
      !(initFilter.price[0] === filter.price[0] &&
        initFilter.price[1] === filter.price[1])
    ) {
      pay.price = {
        min: filter.price[0],
        max: filter.price[1],
      };
    }

    if (
      !(initFilter.experience[0] === filter.experience[0] &&
        initFilter.experience[1] === filter.experience[1])
    ) {
      pay.experience = {
        min: filter.experience[0],
        max: filter.experience[1],
      };
    }

    if (
      !(initFilter.grade[0] === filter.grade[0] &&
        initFilter.grade[1] === filter.grade[1])
    ) {
      pay.grade = {
        min: filter.grade[0],
        max: filter.grade[1],
      };
    }

    return pay;
  };

  const TutorListApi = useCallback(
    async (latitude: any, longitude: any, value: string, filter: any) => {
      const pay = payload(latitude, longitude, value, filter);
      const cacheKey = JSON.stringify(pay);

      if (apiCache.has(cacheKey)) {
        const cachedData = apiCache.get(cacheKey);

        const filtered = (cachedData ?? []).filter(
          (tutor: any) => tutor.is_slots_available === true
        );

        setList(filtered);
        if (initSort?.price || initSort?.rating) {
          handleProceedSort(initSort?.price, initSort?.rating, filtered);
        } else {
          setTutorList(filtered);
        }
        return;
      }

      try {
        const Response = await axiosInstance.post(
          `${API_END_POINTS.OPTIMIZED_TUTOR_LIST}`,
          pay
        );

        const rawData = Response?.data?.result?.data ?? [];

        const filteredData = rawData.filter(
          (tutor: any) => tutor.is_slots_available === true
        );

        apiCache.set(cacheKey, filteredData);

        setList(filteredData);
        if (initSort?.price || initSort?.rating) {
          handleProceedSort(initSort?.price, initSort?.rating, filteredData);
        } else {
          setTutorList(filteredData);
        }
      } catch (error) {
        console.error("Error fetching tutor list", error);
        setList([]);
        setTutorList([]);
      }
    },
    [initSort] 
  );

  
  const searchTutorKeyword = async (search: any) => {
    const payload = {
      search_text: search,
      course_tag: FilterApplyData?.courses ? FilterApplyData?.courses.toString() : "",
    };
    try {
      const Response = await axios.post(
        `${process.env.REACT_APP_BASE_BACKEND_API_URL + API_END_POINTS.TUTOR_KEY_WORD_SEARCH}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setSearchTextList(Response?.data.result?.data);
    } catch (error) {
      console.error("Error fetching search keywords", error);
    }
  };

  const FilterApply = (filter: any) => {
    setIsTrigger(true);
    SetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.TUTOR, JSON.stringify(filter));
    store.dispatch(setTutorFilter(filter));
    setFilterApplyData(filter);
    navigate(ROUTES.TUTORS_LIST_VIEW, {
      state: {
        tutor_list: null,
        search_text: searchValue,
        redius: filter.radius,
        lat: currentLat,
        lang: currentLang,
        filter: filter,
        filterBoolean: true,
      },
    });
  };

  const onInputChange = (value: any) => {
    store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.TUTOR, value);
      if (value?.length > 2) {
        searchTutorKeyword(value);
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    TutorListApi(currentLat, currentLang, searchValue, FilterApplyData);
  };

  const handlePassCoursecategory = (value: any) => {
    if (nullUndefinedEmptyCheck(value)) {
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.TUTOR, value);
      if (value?.includes("near me")) {
        navigate(ROUTES.TUTORS_LIST_VIEW, {
          state: {
            tutor_list: "",
            search_text: value,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLang,
            map_show: true,
            filter: FilterApplyData,
            filterBoolean: IsTrigger,
          },
        });
      } else {
        navigate(ROUTES.TUTORS_LIST_VIEW, {
          state: {
            tutor_list: "",
            search_text: value,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLang,
            map_show: false,
            filter: FilterApplyData,
            filterBoolean: IsTrigger,
          },
        });
      }
    } else {
      TutorListApi(currentLat, currentLang, value, FilterApplyData);
    }
  };

  const onCloseCategoryPop = () => {
    setCategoryPopOpen(false);
  };

  const onNavigate = (content: any) => {
    let provider_id = content.provider_id;
    if (nullUndefinedEmptyCheck(provider_id)) {
      navigate(ROUTES.TUTORS_DETAILE_VIEW + "?id=" + encryptPassData(provider_id));
    } else {
      navigate(ROUTES.TUTORS_LIST_VIEW, {
        state: {
          tutor_list: "",
          search_text: "",
          redius: FilterApplyData.radius,
          lat: currentLat,
          lang: currentLang,
          map_show: false,
          filter: FilterApplyData,
          filterBoolean: IsTrigger,
        },
      });
    }
  };

  const sort: any = GetSessionStorageData("sort");
  useEffect(() => {
    let data = JSON.parse(sort);
    if (data?.price || data?.rating) {
      handleProceedSort(data?.price, data?.rating);
    }
  }, [sort]);

  const handleProceedSort = (checkedPrice: any, checkedRating: any, data: any = null) => {
    const sortedData = data ? [...data] : [...list];
    if (checkedPrice == 'high') {
      sortedData.sort((a: any, b: any) => b?.least_price - a?.least_price);
    } else if (checkedPrice == 'low') {
      sortedData.sort((a: any, b: any) => a?.least_price - b?.least_price);
    } else if (checkedRating == 'high') {
      sortedData.sort((a: any, b: any) => b?.least_rating - a?.least_rating);
    } else if (checkedRating == 'low') {
      sortedData.sort((a: any, b: any) => a?.least_rating - b?.least_rating);
    }
    setTutorList(sortedData);
    setSort({
      price: checkedPrice,
      rating: checkedRating,
    });
  };

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const wrapperClassName_Lang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "tutors-filter-wrap-english" : "tutors-filter-wrap_arabic";
  const TutorCard_Img_wapper_Lang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "TutorCard_Img_wapper-english" : "TutorCard_Img_wapper_arabic";
  const search_button_Lang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "search_button" : "search_button_arabic";
  const Tutor__text__contant_Lang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "Tutor_text_contant_english" : "Tutor_text_contant_arabic";
  const TutorMaps__view_Lang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "TutorMaps__view_english" : "TutorMaps__view_arabic";
  const TutorSubject_Img_span = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "TutorSubject_Img_wapper_span_english" : "TutorSubject_Img_wapper_span_arabic";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(490));

  const handleNavigate = (route: string, routeName: string) => {
    console.log(`Navigating to ${routeName} with route: ${route}`);
    navigate(route);
  };

  return (
    <>
      {CategoryPopOpen && (
        <TutorCategoryPopup
          PopOpen={CategoryPopOpen}
          onClosePop={onCloseCategoryPop}
          currentLat={currentLat}
          currentLang={currentLang}
          CourseData={coursecategory}
          FilterRadiusvalue={FilterApplyData.radius}
          FilterApplyData={FilterApplyData}
        />
      )}
      <div className="row tutor__container">
        {!isMobile && (
          <div className={`TutorCard_Img_wapper ${TutorCard_Img_wapper_Lang}`}>
            <img draggable="false" src={TutorImg} alt="TutorImg" className="" />
            <div className="TutorImg__text">{t("Tutors")}</div>
          </div>
        )}
        {isMobile && (
          <div className="navigation_container">
            <div className="d-flex align-items-center gap-2 navigation-btn">
              <img draggable="false" src={TutorImg} alt="TutorImg" width={24} height={24} />
              <div className="TutorImg__text_activite">{t("Tutors")}</div>
            </div>
            <div
              className="d-flex align-items-center gap-2 navigation-btn"
              onClick={() => handleNavigate(ROUTES.SCHOOLLAYOUT, "Schools")}
            >
              <img draggable="false" src={schoolIocn} alt="TutorImg" width={20} height={20} />
              <div className="TutorImg__text">{t("Schools")}</div>
            </div>
            <div
              className="d-flex align-items-center gap-2 navigation-btn"
              onClick={() => handleNavigate(ROUTES.ACTIVITYLAYOUT, "Activities")}
            >
              <img draggable="false" src={activitiesIcon} alt="TutorImg" width={20} height={20} />
              <div className="TutorImg__text">{t("Activities")}</div>
            </div>
            <div
              className="d-flex align-items-center gap-2 navigation-btn"
              onClick={() => handleNavigate(ROUTES.THEMEPARK__HOMEPAGE, "Parks & Events")}
            >
              <img draggable="false" src={themeParkIcon} alt="TutorImg" width={20} height={20} />
              <div className="TutorImg__text">{t("Parks & Events")}</div>
            </div>
            <div
              className="d-flex align-items-center gap-3 navigation-btn"
              onClick={() => handleNavigate(ROUTES.UNIVERSITYLAYOUT, "Universities")}
            >
              <img draggable="false" src={universityIcon} alt="TutorImg" width={20} height={20} />
              <div className="TutorImg__text">{t("Universities")}</div>
            </div>
          </div>
        )}

        <div className="mb-4 tutors-head-row">
          <div className="tutors-search-part">
            <div className="search_field_wrapper">
              <div className="search__autocomplete">
                <form onSubmit={handleSubmit}>
                  <Autocomplete
                    freeSolo
                    popupIcon={<ExpandMoreIcon />}
                    id="free-solo-2-demo"
                    disableClearable={false}
                    clearIcon={false}
                    value={searchValue}
                    onChange={(e, value) => {
                      const trimedvalue = value ? value.trim() : "";
                      setSearchValue(trimedvalue);
                      handlePassCoursecategory(trimedvalue);
                      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.TUTOR, trimedvalue);
                    }}
                    options={searchTextList?.map((option: any) =>
                      language === GLOBAL_CONSTANTS.LANGUAGES.ARABIC ? option?.arabic_tag_name : option?.tag
                    )}
                    renderOption={(props, option) => (
                      <Box component="li" sx={[{ px: 0.5, py: 0.7 }]} {...props} className="notranslate" translate="no">
                        {option}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={t("Search for tutor")}
                        onChange={(inputChangeEvent: any) => {
                          onInputChange(inputChangeEvent.target.value.trim());
                        }}
                        onKeyDown={(e: any) => {
                          if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                            e.preventDefault();
                            const trimedvalue = searchValue.trim();
                            if (trimedvalue) {
                              handlePassCoursecategory(searchValue);
                            }
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          type: "text",
                        }}
                      />
                    )}
                  />
                  <img
                    draggable="false"
                    src={search}
                    alt="search"
                    className={search_button_Lang}
                    onClick={() => handlePassCoursecategory(searchValue)}
                  />
                </form>
              </div>
            </div>
          </div>
          <div className={`tutors-filter-wrap ${wrapperClassName_Lang}`}>
            <AppFilter
              FilterPopOpen={FilterPopOpen}
              onOpenPop={onOpenFilterPop}
              onClosePop={onCloseFilterPop}
              FilterData={FilterData}
              FilterApply={FilterApply}
              FilterApplyData={FilterApplyData}
              initFilter={initFilter}
              initSort={initSort}
              handleApplySort={handleProceedSort}
              type="tutor"
              color="#178fff"
            />
          </div>
        </div>

        <div className="body_scroll_container">
          <div className="TutorSubject__container">
            {coursecategory?.slice(0, itemsToShow).map((data: any, i: any) => (
              <div
                className="TutorSubject_Img_wapper"
                key={data.id || i}
                onClick={() => handlePassCoursecategory(data?.course_category_name)}
              >
                <img
                  draggable="false"
                  src={nullUndefinedEmptyCheck(data?.display_image) ? data?.display_image : Chemistry}
                  onError={(e: any) => { e.target.src = Chemistry; }}
                  alt="TutorImg"
                  className=""
                />
                <span className={TutorSubject_Img_span}>{data?.course_category_name}</span>
              </div>
            ))}

            {coursecategory?.length > itemsToShow ? (
              <div className="TutorSubject_Img_wapper Show__more" onClick={handleShowMore}>
                <div>{t("Show more")}</div>
              </div>
            ) : ""}
          </div>

          <div className="row scroll__container mt-4 pt-2">
            <div className="tutors-scroll-content-one">
              <div className={`Tutor__text__contant ${Tutor__text__contant_Lang}`}>
                <h1 className="text_contant_h1">
                  <span>{t("LEARN")}</span>
                  <br />
                  <span>{t("from")}</span>
                  <br />
                  <span>{t("the BEST")}</span>
                </h1>
                <p>{t("With 500+ tutors in our platform, find the best tutor for your kid")}</p>
              </div>

              {!isMobile ? (
                <>
                  <div className="Middle__leftside_wapper">
                    {promotionalContent.length > 0 &&
                      promotionalContent.map((content: any, index: number) => {
                        if (index <= 1) {
                          return (
                            <div className="tutorImg4" key={index} onClick={() => onNavigate(content)}>
                              <img
                                src={content.image}
                                alt="tutorImg4"
                                className="Middle__leftside__img"
                                onError={(e: any) => { e.target.src = tutorImg1; }}
                              />
                              <div className="discount__wapper">
                                <div className="discount__flex__column">
                                  <div className="discount__text__contant notranslate">
                                    {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? content?.description : content?.description_ar}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                  </div>

                  {promotionalContent.length > 0 &&
                    promotionalContent.map((content: any, index: number) => {
                      if (index >= 2) {
                        return (
                          <div className="tutorImg1" key={index} onClick={() => onNavigate(content)}>
                            <img
                              src={content.image}
                              alt="tutorImg1"
                              className="Middle__rightside_img"
                              onError={(e: any) => { e.target.src = tutorImg4; }}
                            />
                            <div className="discount__wapper">
                              <div className="discount__flex__column">
                                <div className="discount__flex__row">
                                  <div className="discount__text__contant notranslate">
                                    {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? content?.description : content?.description_ar}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })}
                </>
              ) : (
                <div className="promotional__container">
                  {promotionalContent.length > 0 &&
                    promotionalContent.map((content: any, index: number) => (
                      <div
                        className={index <= 1 ? "tutorImg4 promotional__item" : "tutorImg1 promotional__item"}
                        key={index}
                        onClick={() => onNavigate(content)}
                      >
                        <img
                          src={content.image}
                          alt="promotional-img"
                          className="promotional__img"
                          onError={(e: any) => { e.target.src = index <= 1 ? tutorImg1 : tutorImg4; }}
                        />
                        <div className="discount__wapper">
                          <div className="discount__flex__column">
                            <div className="discount__text__contant notranslate">
                              {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? content?.description : content?.description_ar}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              <div className={`TutorMaps__view ${TutorMaps__view_Lang}`} style={{ height: "400px" }}> {/* Explicit height */}
                {currentLat && currentLang ? (
                  <TutorMaps
                    zoom={12}
                    radius={FilterApplyData.radius * 1000}
                    lat={currentLat}
                    lang={currentLang}
                    containerStyle={containerStyle}
                    disable={true}
                    zoomControl={false}
                    draggable={true}
                    clickableIcons={false}
                    tutorList={tutorList}
                    getOneTutor={[]}
                    filter={isObjectEmptyValue(tutorfilter) ? tutorfilter : FilterApplyData}
                    initFilter={initFilter}
                    searchValue={searchValue}
                    initSort={initSort}
                  />
                ) : (
                  <div>Loading map...</div> 
                )}
                <div className="tutor__viewMap" onClick={() => handleRouteMap(searchValue)}>
                  <img src={ExpandMap} alt="ExpandMap" />
                  <span>{t("View on Map")}</span>
                </div>
              </div>
            </div>

            <div className="tutors_scroll_content_two">
              <div className="top_tutors_container_scroll">
                <TutorCardsCarousel
                  radius={FilterApplyData.radius}
                  lat={currentLat}
                  lang={currentLang}
                />
              </div>

              <div className="top__tutors__container_list">
                <TopTutors
                  tutorList={tutorList}
                  radius={FilterApplyData.radius * 1000}
                  lat={currentLat}
                  lng={currentLang}
                  FilterApplyData={FilterApplyData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TutorsDashboardLayout;